import getApiClient from '@/plugins/api-client'

export default {
    loadTemplate() {
        const self = this,
            api = getApiClient(self.$store),
            templateId = self.$route.params.id

        api.get(`message_templates/${templateId}`)
            .then(result => {
                self.template = result.data
            })
            .catch(error => {
                console.log(error)
            })
    },

    loadWhatsappTemplates() {
        const self = this,
          api = getApiClient(self.$store)

        api.get('whatsapp_templates')
          .then(result => {
              self.whatsappTemplates = result.data['hydra:member'].map(item => {
                  return {
                      label: item.name,
                      value: `/whatsapp_templates/${item.id}`,
                      components: item.components
                  }
              })
            })
    },

    setWhatsappTemplate(template) {
        this.template.whatsappTemplate = template
    },

    updateTemplate() {
        const self = this,
            api = getApiClient(self.$store),
            templateId = self.$route.params.id

        self.resetFormResult()

        api.patch(`message_templates/${templateId}`, self.template, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.template = result.data
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },

    resetFormResult: function() {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = null
        })
        self.success = false
    }
}
